<script lang="ts">
    import type {Price} from 'typings/portaro.be.types';
    import {pipe} from 'core/utils';
    import {priceFormatter} from '../../utils/pipes';
    import {getCurrentLanguage} from 'core/svelte-context/context';

    const currentLanguage = getCurrentLanguage();

    export let price: Price;
</script>

<span class="price-text">{pipe(price, priceFormatter(currentLanguage))}</span>